import { motion } from "framer-motion";

const steps = [
    {
        n: "01",
        title: "Upload je foto's",
        desc: "Deel je vastgoedfoto's via een eenvoudige link. Geen extra shoots nodig.",
    },
    {
        n: "02",
        title: "Wij creëren jouw video",
        desc: "We animeren en monteren tot een cinematische video die perfect aansluit bij jouw branding.",
    },
    {
        n: "03",
        title: "Ontvang je video",
        desc: "Binnen enkele dagen klaar voor gebruik op social media en websites.",
    },
];

export const Process = () => {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="relative py-28 md:py-40 bg-neutral-50"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="max-w-3xl mb-16"
                >
                    <p className="text-[11px] font-bold tracking-[0.3em] uppercase text-neutral-500 mb-5">
                        / 04 — Hoe het werkt
                    </p>
                    <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-black leading-[1.02]">
                        Simpel proces.{" "}
                        <span className="italic font-light text-neutral-400">
                            Sterk resultaat.
                        </span>
                    </h2>
                </motion.div>

                <div className="relative">
                    <div className="hidden lg:block absolute top-[72px] left-[10%] right-[10%] h-[1px] bg-gradient-to-r from-transparent via-black/20 to-transparent" />
                    <div className="grid md:grid-cols-3 gap-5">
                        {steps.map((s, i) => (
                            <motion.div
                                key={s.n}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: i * 0.1 }}
                                data-testid={`process-step-${i}`}
                                className="relative group"
                            >
                                <div className="relative p-8 rounded-3xl bg-white border border-black/5 hover:border-black/30 hover:shadow-[0_20px_50px_-20px_rgba(0,0,0,0.25)] hover:-translate-y-1 transition-all duration-500">
                                    <div className="flex items-center gap-4 mb-8">
                                        <div className="w-12 h-12 rounded-full bg-black text-white font-heading font-bold text-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-500">
                                            {s.n}
                                        </div>
                                        <div className="h-[1px] flex-1 bg-black/10 group-hover:bg-black/30 transition-colors" />
                                    </div>
                                    <h3 className="font-heading text-xl font-bold text-black tracking-tight mb-3 leading-tight">
                                        {s.title}
                                    </h3>
                                    <p className="text-sm text-neutral-600 leading-relaxed">
                                        {s.desc}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
